"use client";

import { Fragment } from "react";

import { RichText } from "@/components/richText/richText.component";

import { MultiColumnContent as MultiColumnContentType } from "@/sanity.types";

export const MultiColumnContent = ({ block }: MultiColumnContentProps) => {
  const columns = block?.columns ?? [];
  if (!columns.length) return null;

  const renderColumns = () => {
    return columns.map((col, index) => {
      const key = col._key ?? `col-${index}`;

      return (
        <Fragment key={key}>
          {/* Divider between columns */}
          {index > 0 ? (
            <hr
              aria-hidden
              className="border-greyscale-strength/20 mx-4 hidden shrink-0 border-0 lg:block lg:h-auto lg:self-stretch lg:border-l"
            />
          ) : null}

          <div className="flex w-full max-w-full min-w-0 flex-1 flex-col text-left max-lg:max-w-lg lg:max-w-none">
            {/* Column content */}
            <div className="text-greyscale-body flex w-full flex-col gap-2 max-lg:text-center lg:text-left">
              <RichText>{col.content}</RichText>
            </div>
          </div>
        </Fragment>
      );
    });
  };

  return (
    <section
      data-testid="multi-column-content"
      className="container mx-auto w-full max-w-full bg-white px-6 py-10 sm:px-20 md:py-12">
      {/* Section title and subtitle */}
      <header className="text-greyscale-headline mx-auto mb-16 flex max-w-3xl flex-col gap-5 text-center lg:gap-4">
        <RichText>{block.headerContent}</RichText>
      </header>

      <div className="flex w-full min-w-0 flex-col gap-16 max-lg:items-center lg:flex-row lg:justify-center lg:gap-x-4 lg:gap-y-0">
        {renderColumns()}
      </div>
    </section>
  );
};

type MultiColumnContentProps = {
  block: MultiColumnContentType;
};
